import React from 'react';
import { CivilDate } from 'tc39-proposal-temporal';
import PropTypes from 'prop-types';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';

export class SpecificRange extends React.PureComponent {
  static defaultProps = {
    selectedRangeId: null,
    onClickSpecificRange: undefined,
  }

  render() {
    return (
      <ol className="specific-part specific-range-select" role="listbox" aria-label={this.props.i18n.getString(_TL_('date options'))} >
        {
          this.props.specificRanges.map(range => (
            <li
              role="option"
              key={range.key}
              onClick={() => this.props.onClickSpecificRange(range.rangeId)}
              onKeyDown={event =>
                submitEvent(this.props.onClickSpecificRange)(event, range.rangeId)}
              className={this.props.selectedRangeId === range.rangeId ? 'selected' : ''}
              data-value={range.key}
              tabIndex="0"
              aria-selected={this.props.selectedRangeId === range.rangeId}
            >
              { range.text}
            </li>
          ))
        }
      </ol >
    );
  }
}

SpecificRange.propTypes = {
  specificRanges: PropTypes.arrayOf(PropTypes.shape({
    rangeId: PropTypes.number,
    key: PropTypes.string,
    range: PropTypes.shape({
      start: PropTypes.instanceOf(CivilDate),
      end: PropTypes.instanceOf(CivilDate),
    }),
  })).isRequired,
  onClickSpecificRange: PropTypes.func,
  selectedRangeId: PropTypes.number,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
